import { schema } from "normalizr";
import { CollectionPermission } from "./collection-permission";

export const CollectionPermissions = new schema.Array(CollectionPermission);
